import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Timestamp({data}) {
    return (
        <div className="time_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="m-auto">
                        <h5 className="episode_name text-start">
                            Timestamps
                        </h5>
                        <ul className="timestamp">
                            <li><span>00:08</span> What it means to be a Chief Marketing Officer (CMO)?</li>
                            <li><span>00:36</span> Guest Introduction – Paul McGillivray.</li>
                            <li><span>01:43</span> What it means to be a Chief Technology Officer (CTO)?</li>
                            <ul className="sub__list">
                                <li> - The start of Code Assembly</li>
                                <li> - The change in technology in the last decade</li>
                                <li> - Internal hindrance to developing Code Assembly and applying automation.</li>
                            </ul>
                            <li><span>15:31</span> The challenges of launching a digital product from scratch.</li>
                            <ul className="sub__list">
                                <li> - The problem of getting stuck in your big picture vision.</li>
                                <li> - The importance of using lean methodology and prototyping.</li>
                            </ul>
                            <li><span>20:20</span> Finding synergy between digital products and your services.</li>
                            <li><span>24:20</span> <strong>Panelist Question #1</strong> – How do you reign in
                                clients who are stuck in
                                their big picture vision and convince them to make MVPs and apply lean methodology.
                            </li>
                            <ul className="sub__list">
                                <li> - Theory of constraints and how it applies to businesses</li>
                                <li> - Identifying purpose of individual tasks and tying them to the end goal.</li>
                                <li> - Researching value factors using a functional specification document</li>
                            </ul>
                            <li><span>32:46</span> When should companies decide not to work with a client?</li>
                            <ul className="sub__list">
                                <li> - The concept of “graduating” a client.</li>
                            </ul>
                            <li><span>38:39</span> <strong>Panelist Question #2</strong> -Is automation only
                                applicable at positions of
                                mundane tasks?
                            </li>
                            <ul className="sub__list">
                                <li> - Understanding margin of error and human error possibility.</li>
                                <li> - Self-driving cars as an application of automation outside the traditional
                                    mundane.
                                </li>
                            </ul>
                            <li><span>50:04</span> What kind of automation works for visual impact on an E-commerce
                                platform?
                            </li>
                            <ul className="sub__list">
                                <li> - Using Augmented Reality(AR) and Virtual Reality (VR).</li>
                                <li> - A/B testing using automation on E-commerce platforms</li>
                            </ul>
                            <li><span>57:24</span> <strong>Panelist Question #3</strong> – How to split automation
                                efforts into small
                                components and be more agile in process implementation?
                            </li>
                            <ul className="sub__list">
                                <li> - Using a clarity workshop to improve your business understanding</li>
                                <li> - Touch point based documentation of the customer journey to identify opportunities
                                    to
                                    delight.
                                </li>
                            </ul>

                        </ul>
                    </Col>
                </Row>

            </Container>
        </div>
    );
}

export default Timestamp;